<template lang="pug">
  .map-year-update(v-if="openedStateVariable")
    transition
      .modal
        .modal__container
          .modal__body
            e-form(:formValidator="formValidator")
              div
                h1 Обновить схему моделирования?
                p Вернуться к текущей схеме моделирования будет невозможно

          .modal__footer
            .actions-filter-panel.actions-filter-panel--right
              div
                button(type="button" @click="close()").reset-btn.button.button_no-border.button_color.modal__button Нет
                button(type="button" @click="deleteYear()").button.reset-btn.button_save.semibold Да
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { threads } from '@/api/api-endpoints'

export default {
  name: 'map-year-delete',
  mixins: [formBaseMixin],
  title: false,
  props: ['openedStateVariable', 'yearMapId'],
  methods: {
    deleteYear() {
      this.$store.commit('preloaderStart')
      this.$store
        .dispatch('createModel', {
          url: threads.delete(),
          endpoint: threads.delete(),
        })
        .then(() => {
          this.$store.commit('preloaderEnd')
          this.$emit('closeForm')
          this.$router.push(this.$route.path)
        })
        .catch(() => {
          this.$store.commit('preloaderEnd')
        })
    },
    close() {
      this.$emit('closeForm')
    },
  },
}
</script>
